import { Checkbox, ItemIcon, Type } from "@similarweb/ui-components";
import {
    DropdownSegmentItemWrapper,
    GroupItemSubText,
    GroupItemText,
    GroupTextWrapper,
    GroupWrapper,
    SegmentNameLabel,
    SegmentTypeBadge,
} from "../../styles";
import type { SelectedSegmentsId } from "../../types";
import type { ICustomSegmentAccount } from "app/services/segments/segmentsApiService";

type DropdownItemProps = {
    segment: ICustomSegmentAccount;
    setSelectedSegmentsId: (id: ICustomSegmentAccount) => void;
    isSelectionDisabled: boolean;
    selectedIds?: SelectedSegmentsId;
};

const DropdownItem = ({ segment, setSelectedSegmentsId, selectedIds, isSelectionDisabled }: DropdownItemProps) => {
    const isSelected = selectedIds[segment.id];
    const isDisabled = isSelectionDisabled && !isSelected;

    return (
        <DropdownSegmentItemWrapper id={segment.id}>
            <GroupWrapper>
                <ItemIcon
                    iconSrc={segment.favicon}
                    iconType={Type.Website}
                />
                <GroupTextWrapper>
                    <GroupItemText>{segment.domain}</GroupItemText>
                    {segment.type === "WEBSITE" ? (
                        <SegmentNameLabel>
                            <SegmentTypeBadge>WEBSITE</SegmentTypeBadge>
                        </SegmentNameLabel>
                    ) : (
                        <GroupItemSubText>{segment.segmentName}</GroupItemSubText>
                    )}
                </GroupTextWrapper>
            </GroupWrapper>
            <Checkbox
                selected={isSelected}
                onClick={() => !isDisabled && setSelectedSegmentsId(segment)}
                label=""
                isDisabled={isDisabled}
            />
        </DropdownSegmentItemWrapper>
    );
};

export default DropdownItem;
